import theme from '@css/theme';
import styled from 'styled-components';
import AntSelect from 'antd/lib/select';

export const StyledSelect = styled(AntSelect)`
  &.ant-select {
    width: 100%;
    height: 40px !important;
  }
  .ant-select-selector {
    height: 100% !important;
    background: #ffffff !important;
    border: 1px solid ${theme.color.border} !important;
    border-radius: 2px !important;
    display: flex !important;
    align-items: center;
    padding: 8px !important;
  }
  .ant-select-selection-item {
    font-size: 1rem;
    line-height: 24px !important;
    font-family: ${theme.text.fontFamily};
    font-weight: 400 !important;
    color: ${theme.text.color.primary};
  }
  .ant-select-arrow {
    color: ${theme.color.neutral1} !important;
  }
  .ant-select-selection-search {
    align-items: center;
    display: flex;
  }

  /* disabled */
  &.ant-select-disabled .ant-select-selector {
    background: ${theme.color.background1} !important;
  }
  &.ant-select-disabled .ant-select-selector .ant-select-selection-item {
    color: ${theme.text.color.disabled} !important;
  }
  &.ant-select-disabled .ant-select-arrow {
    color: ${theme.text.color.disabled} !important;
  }

  /* open */
  &.ant-select-open .ant-select-selector {
    border: 1px solid ${theme.color.rsPrimary} !important;
  }
  &.ant-select-open .ant-select-selector .ant-select-selection-item {
    color: ${theme.color.rsPrimary} !important;
  }
  &.ant-select-open .ant-select-arrow {
    color: ${theme.color.rsPrimary} !important;
  }

  /* focused */
  &.ant-select-focused .ant-select-selector {
    box-shadow: none !important;
  }
`;

export const MultiSelectContainer = styled(AntSelect)`
  .ant-select-arrow {
    color: ${theme.color.neutral1} !important;
  }
`;
